import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../components/Footer';
import PaymentModal from '../components/PaymentModal';
import SeoTags from '../components/SeoComponent';
import { getCanonicalLink, SeoTexts } from '../services/SEO';
import NavFooter from '../components/NavFooter';

// Rendered as a route `element` rather than wrapping <Route> itself: v6 routes
// take an element, and the guard no longer has route props to forward -- the
// wrapped component reads what it needs from the router hooks.
const PublicRoute = ({ component: Component, hideFooter }) => (
  <React.Fragment>
    <Component />
    <Footer />
    {!hideFooter && <NavFooter />}
    <PaymentModal />
    <SeoTags
      title={SeoTexts.JEN_WEB_TITLE}
      canonicalLink={getCanonicalLink()}
      metaDescription={SeoTexts.JEN_WEB_DESCRIPTION}
      ogImgUrl={SeoTexts.JEN_WEB_OG_IMAGE_URL}
      twitterImgUrl={SeoTexts.JEN_WEB_TWITTER_IMAGE_URL}
    />
  </React.Fragment>
);

PublicRoute.propTypes = {
  component: PropTypes.any,
  hideFooter: PropTypes.bool,
};

export default PublicRoute;
